<template>
  <q-td
    :key="props.name"
    :props="props"
  >
    <div class="row no-wrap items-center q-gutter-xs">
      <slot name="actions">
        <div
          v-if="actions && actions.length"
          class="col-auto"
        >
          <q-btn
            flat
            round
            dense
            icon="fa fa-ellipsis-v"
            color="primary-app"
            @click.stop
          >
            <lwf-menu
              dense
              :options="actions"
              :context="props.row"
            />
          </q-btn>
        </div>
      </slot>
      <div
        v-if="avatar"
        class="col-auto"
      >
        <q-avatar color="secondary">
          <lwf-photo
            v-if="avatarPicture"
            :picture="avatarPicture"
            img
          />
          <span v-else>{{ _.get(value, [0, 0]) }}</span>
        </q-avatar>
      </div>
      <div class="col">
        <div
          v-for="(d, i) in value"
          :key="i"
        >
          {{ d }}
        </div>
      </div>
      <div class="col">
        <slot name="badge" />
      </div>
    </div>
  </q-td>
</template>

<script>
import LwfMenu from 'components/core/LwfMenu'
import LwfPhoto from 'components/core/LwfPhoto'

export default {
  name: 'LwfTdMultiline',
  components: { LwfPhoto, LwfMenu },
  inheritAttrs: false,
  props: {
    props: {
      type: Object,
      default: undefined
    },
    avatar: Boolean,
    avatarPicture: {
      type: Object,
      default: undefined
    },
    actions: {
      type: Array,
      default: undefined
    }
  },
  computed: {
    value () {
      const { props: { value } } = this
      return Array.isArray(value)
        ? value
        : [value]
    }
  }
}
</script>

<style scoped>

</style>
